export function signOutRedirect() {
  const clientId = '4cqhr3p5m9r4p4e81qk6m4de78';
  const logoutUri = 'https://master.d2mi4shpisjxo0.amplifyapp.com/';
  const cognitoDomain = 'https://<your-cognito-domain>.auth.us-east-2.amazoncognito.com';

  window.location.href =
    `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}